// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HpbI","badges":"styles_badges__HZzpm"};